<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 6v12H4V6h16m1-2H3a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V5a1 1 0 00-1-1z"/><path d="M16 13.5a.47.47 0 01-.35-.15L12 9.71l-3.65 3.64a.49.49 0 01-.7-.7l4-4a.48.48 0 01.7 0l4 4a.48.48 0 010 .7.47.47 0 01-.35.15z"/><path d="M14.15 14.15l-1.8-1.8a.5.5 0 00-.7 0l-1.8 1.8a.5.5 0 00.36.85h3.58a.5.5 0 00.36-.85z"/></svg>